export default __webpack_public_path__ + "static/media/logout.db9e6569.svg";